import { closestCenter, pointerWithin, type CollisionDetection } from '@dnd-kit/core';

const SLOT_INSERT_ID_PREFIX = 'slot-insert__';

/**
 * 日历上针对 slot / 整日条目的拖拽碰撞：插入缝（slot-insert__*）与整块 sortable 卡重叠时，
 * 默认 closestCenter 会优先命中整块卡导致跨日落点误判；指针在重叠区内时优先返回 slot-insert 命中。
 */
export const slotDndCollisionDetection: CollisionDetection = (args) => {
  const pointerCollisions = pointerWithin(args);
  if (pointerCollisions.length > 0) {
    const insertHits = pointerCollisions.filter((c) => String(c.id).startsWith(SLOT_INSERT_ID_PREFIX));
    if (insertHits.length > 0) {
      return insertHits;
    }
    return pointerCollisions;
  }
  return closestCenter(args);
};
